module.exports = __webpack_public_path__ + "img/offer-ico_5.509b9f21.png";